import { render, staticRenderFns } from "./NewAdd.vue?vue&type=template&id=b8ff0edc&scoped=true&"
import script from "./NewAdd.vue?vue&type=script&lang=js&"
export * from "./NewAdd.vue?vue&type=script&lang=js&"
import style0 from "./NewAdd.vue?vue&type=style&index=0&id=b8ff0edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ff0edc",
  null
  
)

export default component.exports